require("../../scss/proyectoInterna.scss");
import SliderResponsive from '../componentes/SliderResponsive.js';
import Chart from 'chart.js/dist/Chart.js';
import ScrollReveal from 'scrollreveal';

Chart.pluginService.register({
	beforeDraw: function (chart) {
		if (chart.config.options.elements.center) {
		    //Get ctx from string
		    var ctx = chart.chart.ctx;
		    
			//Get options from the center object in options
		    var centerConfig = chart.config.options.elements.center;
		  	var fontStyle = centerConfig.fontStyle || 'Arial';
			var txt = centerConfig.text;
		    var color = centerConfig.color || '#000';
		    var sidePadding = centerConfig.sidePadding || 20;
		    var sidePaddingCalculated = (sidePadding/100) * (chart.innerRadius * 2)
		    //Start with a base font of 30px
		    ctx.font = "38px " + fontStyle;
		    
			//Get the width of the string and also the width of the element minus 10 to give it 5px side padding
		    var stringWidth = ctx.measureText(txt).width;
		    var elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;

		    // Find out how much the font can grow in width.
		    var widthRatio = elementWidth / stringWidth;
		    var newFontSize = Math.floor(29 * widthRatio);
		    var elementHeight = (chart.innerRadius * 2);

		    // Pick a new font size so it will not be larger than the height of label.
		    var fontSizeToUse = Math.min(newFontSize, elementHeight);

			//Set font settings to draw it correctly.
		    ctx.textAlign = 'center';
		    ctx.textBaseline = 'middle';
		    var centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
		    var centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
		    ctx.font = fontSizeToUse+"px " + fontStyle;
		    ctx.fillStyle = color;
		    
		    //Draw text in center
		    ctx.fillText(txt, centerX, centerY);

		    //draw circle
		    ctx.beginPath();
			ctx.arc(centerX, centerY, (elementHeight/2)*1, 0, 2 * Math.PI);
			ctx.strokeStyle=color;
			ctx.stroke();
		}
	}
});

var proyectoInterna = function(){
	
	var heroSlider = null;
	var detallesSlider = null;

	constructor = function(){
		//sliders
		heroSlider = new SliderResponsive({
            target:"#hero_galeria",
            tiempoAuto:4,
            flechas:false,
            md:550,
            puntos:true,
            puntosContainer: $("#puntosContainer")
        });

        detallesSlider = new SliderResponsive({
            target:"#galeriaDetalles",
            tiempoAuto:4,
            flechas:false,
            md:550,
            puntos:true
        });


		var baseConfig = {
			type: 'doughnut',
			data: {
				datasets: [
					{
						data: [
							50,
							50,
						],
						backgroundColor: [
							"#ffffff",
							"rgba(0,0,0,0)",
						],
						hoverBackgroundColor: [
							"#ffffff",
							"rgba(0,0,0,0)",
						],
						borderColor:[
							"rgba(0,0,0,0)",
							"rgba(0,0,0,0)",
						]
					}
				]
			},
			options: {
				responsive: true,
				maintainAspectRatio: true,
				legend:{
					display: false,
				},
				title: {
					display: false,
				},
				tooltips: {
					enabled: false,
				},
				animation: {
					animateScale: false,
					animateRotate: true,
					duration: 5000
				},
				elements: {
					center: {
						text: '90%',
						color: '#FFFFFF', // Default is #000000
						fontStyle: 'Roboto Condensed', // Default is Arial
						sidePadding: 20 // Defualt is 20 (as a percentage)
					}
				},
				cutoutPercentage: 70
			}
		};

		var graph = {
			distance: "10%",
		}

		ScrollReveal().reveal("*[data-reveal='graph']", graph);

        //statics
        var leedEnergia = document.getElementById("leedEnergia");
        if(leedEnergia){
	        var cfgleedEnergia = JSON.parse(JSON.stringify(baseConfig));
	        var valueleedEnergia = parseInt(leedEnergia.getAttribute("data-percent"));
	        cfgleedEnergia.data.datasets[0].data[0] = valueleedEnergia;
	        cfgleedEnergia.data.datasets[0].data[1] = 100 - valueleedEnergia;
	        cfgleedEnergia.options.elements.center.text = valueleedEnergia+"%";
	        var cleed = new Chart(leedEnergia, cfgleedEnergia);
        }

        var leedAgua = document.getElementById("leedAgua");
        if(leedAgua){
	        var cfgleedAgua = JSON.parse(JSON.stringify(baseConfig));
	        var valueleedAgua = parseInt(leedAgua.getAttribute("data-percent"));
	        cfgleedAgua.data.datasets[0].data[0] = valueleedAgua;
	        cfgleedAgua.data.datasets[0].data[1] = 100 - valueleedAgua;
	        cfgleedAgua.options.elements.center.text = valueleedAgua+"%";
	        var cleed = new Chart(leedAgua, cfgleedAgua);
	    }


        var leedMateriales = document.getElementById("leedMateriales");
        if(leedMateriales){
	        var cfgleedMateriales = JSON.parse(JSON.stringify(baseConfig));
	        var valueleedMateriales = parseInt(leedMateriales.getAttribute("data-percent"));
	        cfgleedMateriales.data.datasets[0].data[0] = valueleedMateriales;
	        cfgleedMateriales.data.datasets[0].data[1] = 100 - valueleedMateriales;
	        cfgleedMateriales.options.elements.center.text = valueleedMateriales+"%";
	        var cleed = new Chart(leedMateriales, cfgleedMateriales);
    	}

        //common events
        $("#scrollNext").click(function(){
        	window.APP.scrollToElem("section.detalles");
        	return false;
        })

        //equal rows
		$('.hero .equalRow .equalCol').matchHeight();
		$('.detalles .equalRow .equalCol').matchHeight();
		$('.leed .equalRow .equalCol').matchHeight();
	}

	resizeWin = function(viewportSize){

	}

	var setupMap = function(){
		
		var mapContainer = document.getElementById('mapa');
		if(mapContainer){
			var latlngdata = $(mapContainer).data("latlng");
			latlngdata = String(latlngdata).split(",");
			var myLatLng = {lat: parseFloat(latlngdata[0]), lng: parseFloat(latlngdata[1])};

	        var map = new google.maps.Map(mapContainer, {
	          zoom: 18,
	          center: myLatLng,
  			  mapTypeId: 'satellite',
    		  mapTypeControl: false,
    		  fullscreenControl: false,
    		  rotateControl: false,
    		  streetViewControl: false,
    		  tilt: 20
	        });

	        var marker = new google.maps.Marker({
	          position: myLatLng,
	          map: map,
	          icon: window.markerIcon,
	          title: window.markerTitle
	        });
        }
	}

	$(document).ready(constructor);
	window.initMap = setupMap;

	return {
		resize: resizeWin,
		hola: "mundo"
	}
}

proyectoInterna();